import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { NBasketDeliveryMethods } from './basket-delivery-methods.namespace';

@Injectable({
    providedIn: 'root'
})
export class BasketDeliveryMethodsService {
    private requestService = inject(RequestService);

    async getDeliveryMethods(status?: Status): Promise<NBasketDeliveryMethods.IResponse> {
        return this.requestService.send(status, {
            path: NBasketDeliveryMethods.ENDPOINTS.loadRate
        });
    }

    isCollectionMethod(method: Checkout.IShippingMethod): boolean {
        return NBasketDeliveryMethods.COLLECTION_CODES.includes(method.code);
    }
}
